export interface IError {
    code: string;
    message?: string;
    field?: string;
}

export const isApiError = (error: unknown): error is IError => {
    return typeof error === "object" && error !== null && (error as { code: string }).code !== undefined;
};
